import React from "react";
import { Dialog, Flex, Text, TextField, Button } from "@radix-ui/themes";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/solid";

export function AuthAtreemoDialog({ isOpen, onOpenChange, onCancel, onSave, handleUsernameChange, handlePasswordChange, handleHostChange, isUsernameValid, isPasswordValid, isHostValid, isLoading, title = "Connect Atreemo" }) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content maxWidth="600px" maxHeight="690px" align="center">
        <Dialog.Title>{title}</Dialog.Title>
        <Dialog.Description size="2" mb="4">
          To find your password, log into Atreemo and navigate to Settings → 'Password Access' to copy or create one. See Atreemo's developer guide for details. If you don't have your Atreemo Account
          details on hand, contact the Atreemo Customer Success team.
        </Dialog.Description>

        <Flex style={{ flex: 1, paddingBottom: "1rem" }} direction="column" align="start" gap="1">
          <Text size="2" weight="medium">Host</Text>
          <TextField.Root
            onChange={handleHostChange}
            style={{ width: "100%" }}
            size="2"
            variant="surface"
          />
          {!isHostValid && (
            <Text size="1" weight="regular" color="red">
              Please enter a valid host URL beginning with https://
            </Text>
          )}
        </Flex>

        <Flex className="slot-container" style={{ alignSelf: "stretch" }} display="flex" direction="row" align="start" gap="5">
          <Flex className="api-key-field" style={{ flex: 1 }} display="flex" direction="column" align="start" gap="1">
            <Text size="2" weight="medium">
              Username
            </Text>
            <TextField.Root onChange={handleUsernameChange} placeholder="Paste your username here" style={{ width: "100%" }} size="2" variant="surface" />
            {!isUsernameValid && (
              <Text size="1" weight="regular" color="red">
                Please enter a valid username.
              </Text>
            )}
          </Flex>

          <Flex className="account-id-field" style={{ flex: 1 }} display="flex" direction="column" align="start" gap="1">
            <Text size="2" weight="medium">
              Password
            </Text>
            <TextField.Root onChange={handlePasswordChange} placeholder="Paste your password here" style={{ width: "100%" }} size="2" variant="surface" />
            {!isPasswordValid && (
              <Text size="1" weight="regular" color="red">
                Please enter a valid password.
              </Text>
            )}
          </Flex>
        </Flex>

        <Flex
          style={{
            alignSelf: "stretch",
            width: "100%",
          }}
          display="flex"
          justify="between"
          align="center"
          mt="4"
        >
          <Button size="2" variant="ghost" color="gray" onClick={() => window.open("https://dashboard.airship.co.uk/personal-access-tokens", "_blank")}>
            <Flex display="flex" align="center" gap="2">
              Open Airship
              <ArrowTopRightOnSquareIcon style={{ width: "16px", height: "16px" }} />
            </Flex>
          </Button>

          <Flex display="flex" gap="3" justify="end">
            <Dialog.Close>
              <Button onClick={onCancel} size="2" variant="soft" color="gray">
                Cancel
              </Button>
            </Dialog.Close>
            <Button onClick={onSave} size="2" variant="soft" color="accent" loading={isLoading}>
              Save and continue
            </Button>
          </Flex>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
